import type { FunctionComponent } from 'react';
import { memo } from 'react';
import { useMatch, Outlet } from 'react-router-dom';

import { useLayout } from '../../../main/util/layout-context';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { AccountMenu } from '../../components/account-menu/account-menu';

import { userAccountSections } from './account-menu.constants';
import styles from './account.module.scss';

const style = createStyleHelper(styles, 'account');

export interface IUserAccountProps {
    className?: string;
}

export const UserAccountLayout: FunctionComponent<IUserAccountProps> = memo(({ className }) => {
    const selected = useMatch(':locale/account/:slug/*');
    useLayout({
        showNavButtons: true,
        title: 'account.my-account',
    });

    return (
        <div className={createClassName([className, style()])}>
            <AccountMenu
                className={style('menu')}
                currentPage={selected?.params.slug || ''}
                userAccountSections={userAccountSections}
            />

            <div className={style('section')}>
                <Outlet />
            </div>
        </div>
    );
});
